import LegendCard from "../../components/LegendCard";

export default function LookupEmptyState() {
  return (
    <div className="mt-10 grid grid-cols-1 lg:grid-cols-3 gap-6">
      <div className="lg:col-span-2 bg-white border border-border/60 rounded-2xl shadow-sm p-8">
        <div className="text-[11px] uppercase tracking-[0.2em] text-[#5B695E] mb-3">
          How it works
        </div>
        <h3 className="font-heading text-2xl tracking-tight mb-4">
          Latest data, every lookup.
        </h3>
        <ol className="space-y-3 text-sm text-[#5B695E] list-decimal list-inside">
          <li>The first 4 digits of your parcel ID pick the right DEP range page.</li>
          <li>
            We scrape that page for the current{" "}
            <span className="font-mono text-[#111812]">Collier_Determ_XXXX-XXXX</span> PDF.
          </li>
          <li>New file? We replace the cached copy automatically and re-index it.</li>
          <li>Your parcel is searched line-by-line and the determination code is extracted.</li>
        </ol>
      </div>
      <LegendCard />
    </div>
  );
}
